import { render } from "./youtube.vue?vue&type=template&id=765b7247&scoped=true"
import script from "./youtube.vue?vue&type=script&lang=js"
export * from "./youtube.vue?vue&type=script&lang=js"

import "./youtube.vue?vue&type=style&index=0&id=765b7247&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-765b7247"]])

export default __exports__